import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  // Om användaren inte är inloggad, skicka till login
  if (user === undefined) return <p>Laddar...</p>; // waiting for auth
  if (!user) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;